import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import { TranslationKeys } from 'types/TranslationKeys'

export interface Quotation1Props {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useQuotation1 = (props: Quotation1Props) => {
  const quotationsData = useSelector(
    (state: RootState) => state.about.quotations
  )

  return {
    ...props,
    quotationsData,
  }
}
